export default __webpack_public_path__ + "static/media/img-eu.7654f964.png";